

import React from 'react';
import { FaWhatsapp, FaInstagram, FaFacebook, FaYoutube } from 'react-icons/fa';
import './menu.css'
const Icons = () => {
  const whatsappNumber = '919063906314'; // Include country code (e.g., +91 for India)

  const handleRedirect = (platform) => {
    switch (platform) {
      case 'whatsapp':
        window.open(`https://wa.me/${whatsappNumber}`, '_blank');
        break;
      case 'youtube':
        window.open('https://youtube.com/@maamaashouse', '_blank');
        break;
      case 'instagram':
        window.open('https://www.instagram.com/maamaashouse', '_blank');
        break;
      case 'facebook':
        window.open('https://www.facebook.com/yourprofile', '_blank');
        break;
      default:
        break;
    }
  };

  const icons = [
    {
      platform: 'whatsapp',
      icon: <FaWhatsapp size={24} color="#fff" />,
      // label: 'WhatsApp',
      bg: '#25D366',
    },
    {
      platform: 'youtube',
      icon: <FaYoutube size={24} color="#fff" />,
      // label: 'YouTube',
      bg: '#FF0000',
    },
    {
      platform: 'instagram',
      icon: <FaInstagram size={24} color="#fff" />,
      // label: 'Instagram',
      bg:
        'radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%,#d6249f 60%,#285AEB 90%)',
    },
    {
      platform: 'facebook',
      icon: <FaFacebook size={24} color="#fff" />,
      // label: 'Facebook',
      bg: '#1877F2',
    },
  ];

  return (
    <section className="counter-section">
      <div className="container">
        <div
          className="row"
          style={{
            // marginTop: '-120px',
            textAlign: 'center',
            // display: 'flex',
            justifyContent: 'center',
            gap: '0px',
            flexWrap: 'wrap',
          }}
        >
          {icons.map(({ platform, icon, label, bg }, index) => (
            <div key={index} onClick={() => handleRedirect(platform)} style={styles.item}>
              <div style={{ ...styles.circle, background: bg }}>{icon}</div>
              <h3 style={styles.label}>{label}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  item: {
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '73px',
  /* Mobile styles for 320px */
  '@media (max-width: 320px)': {
    width: '24px',
    marginBottom: '8px', /* Adds bottom margin */
    /* Additional mobile optimizations */
    padding: '4px',
    fontSize: '12px',
  },
  /* Tablet styles for better scaling */
  '@media (min-width: 321px) and (max-width: 768px)': {
    width: '60px',
    marginBottom: '12px',
  }
},
  circle: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  },
  label: {
    fontSize: '14px',
    color: '#fff',
    margin: 0,
  },
};

export default Icons;

